/**
 * Id of the chat's scroll container. The compact and full-screen layouts mount
 * different DOM nodes but reuse this id, so anything that needs to scroll the
 * thread (product "view todos" jump, the thread's own auto-scroll) looks it up
 * by this single constant. Kept in a leaf module so the panel and the thread
 * can share it without importing each other (which would form an import cycle).
 */
export const LABRA_CHAT_SCROLL_ID = 'labra-chat-scroll'
